import { useDispatch } from "react-redux";
import { useBootstrapUser as useLinklfluenceBootstrapUser } from "@linkfluence/core/user/use-cases";
import { Event as ProjectEvent } from "@kol/core/projects/action";

export function useBootstrapUser() {
  const dispatch = useDispatch();
  return useLinklfluenceBootstrapUser(() => {
    dispatch(ProjectEvent.load());
  });
}
